import Axios from '../../utils/axios';
import { getBackendErrorMessage } from '../../utils/errorHandler';

export interface Pitstop {
  id: number;
  ID?: number;
  name: string;
  address?: string;
  // Core's Pitstop table declares both NOT NULL, and /v1/pitstop selects every
  // column, so these have always been in the response — they were just never
  // declared here. Optional anyway: this interface is hand-written, and a hub
  // returned by an older core deploy should not fail to type.
  //
  // Strings, not numbers: they are forwarded into a maps URL and never computed
  // with, and JSON.parse on a DECIMAL is where trailing precision goes missing.
  latitude?: string;
  longitude?: string;
  city: {
    id: number;
    name: string;
    code: string;
    uuid: string;
    province_id: number;
    is_active: boolean;
    created_at: string;
    timezone: string;
    google_place_id: string;
    wilayahid_code: string;
  };
  cityID?: number;
  cityName?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PitstopListResponse {
  data: Pitstop[];
  pagination: {
    total: number;
    page: number;
    size: number;
    lastPage: number;
  };
}

export const getListPitstop = async (params: {
  page?: string;
  size?: string;
  search?: string;
  type?: string;
  hasStaff?: boolean;
}): Promise<PitstopListResponse> => {
  try {
    const response = await Axios.get('/v1/pitstop', { params });
    return response.data;
  } catch (error) {
    throw new Error(getBackendErrorMessage(error));
  }
};
